<script setup>
import { ref, defineProps, defineEmits } from 'vue';

const props = defineProps({
	menu: {
		type: Array,
		required: true,
	},
});

const menu = ref([...props.menu]);

const emit = defineEmits(['close']);

const close = () => {
	emit('close');
};

const deleteItem = (index) => {
	menu.value.splice(index, 1);
};

const addItem = () => {
	menu.value.push({
		name: '',
	});
};
const submit = () => {
	emit('update', menu.value);
};
</script>
<template>
	<div class="fixed inset-y-0 right-0 flex side-over z-50 w-screen md:w-2/5">
		<div
			class="h-full w-full flex flex-col bg-white shadow-xl overflow-y-auto"
		>
			<div class="px-6 py-8 bg-blue-50">
				<div class="flex items-start justify-between">
					<div class="flex items-center">
						<img
							src="@/assets/images/icons/pen.png"
							alt="edit"
							class="w-6 h-6"
						/>
						<div class="text-2xl font-bold text-neutral-700 ml-2">
							Chỉnh sửa
						</div>
					</div>
					<div class="cursor-pointer" @click="close">
						<svg
							class="h-6 w-6"
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
							aria-hidden="true"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M6 18L18 6M6 6l12 12"
							/>
						</svg>
					</div>
				</div>
			</div>
			<div
				class="sideover-content mt-6 relative flex-1 px-4 sm:px-6"
				style="scroll-behavior: smooth"
				id="slide-over"
			>
				<div v-for="(item, index) in menu" :key="item.id" class="mb-4">
					<div class="text-neutral-400 w-1/2 text-xs uppercase mb-2">
						Bữa {{ index === 0 ? 'đầu tiên' : 'thứ' }}
						{{ index !== 0 ? index + 1 : '' }} trong ngày
					</div>
					<div class="input-group">
						<input
							v-model="item.name"
							class="bg-white input-with-icon"
							placeholder="Tìm bữa ăn"
							type="text"
						/>
						<div
							class="input-icon absolute top-1/2 cursor-pointer"
							@click="deleteItem(index)"
						>
							<img
								src="@/assets/images/icons/trash.png"
								alt="edit"
								class="w-4 h-4"
							/>
						</div>
					</div>
				</div>
				<div
					class="text-right text-yellow-700 font-semibold text-sm cursor-pointer"
					@click="addItem"
				>
					Thêm bữa ăn
				</div>
			</div>
			<div class="px-6 py-4 border-t border-yellow-50">
				<div class="flex justify-end">
					<div>
						<button
							type="button"
							class="button-p text-center w-32"
							@click="submit"
						>
							Xác nhận
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>